// Permissions are encoded in the type-system through the `Permissions` type
// New permissions must be added to the `Permissions` type
// New permissions do not need an exported const

/** @deprecated use `Permissions` type */
export const ACCESS_RECYCLE_BIN = 'AccessRecycleBin'
/** @deprecated use `Permissions` type */
export const ADD_METADATA_COMMAND_UI = 'AddMetadataCommandUI'
/** @deprecated use `Permissions` type */
export const ADMIN_ACD_CONFIGURATION = 'AdministerACDConfiguration'
/** @deprecated use `Permissions` type */
export const ADMIN_AUDIO_ANALYTICS = 'AdminAudioAnalytics'
/** @deprecated use `Permissions` type */
export const ADMIN_DESKTOP_ANALYTICS = 'AdminDesktopAnalytics'
/** @deprecated use `Permissions` type */
export const ADMIN_EVALUATION_FORM = 'EvaluationForm'
/** @deprecated use `Permissions` type */
export const ADMIN_LVCSR_ANALYTICS = 'AdminLvcsrAnalytics'
/** @deprecated use `Permissions` type */
export const ADMIN_TEXT_ANALYTICS = 'AdminTextAnalytics'
/** @deprecated use `Permissions` type */
export const ADMINISTER_ANALYTICS_SETTINGS = 'AdministerAnalyticsSettings'
/** @deprecated use `Permissions` type */
export const ADMINISTER_DASHBOARD = 'AdministerDashboard'
/** @deprecated use `Permissions` type */
export const ADMINISTER_DISTRIBUTION_LIST = 'AdministerDistributionList'
/** @deprecated use `Permissions` type */
export const ADMINISTER_MESSAGING = 'AdministerMessaging'
/** @deprecated use `Permissions` type */
export const ADMINISTER_QM_REPORTS = 'AdministerQMReports'
/** @deprecated use `Permissions` type */
export const ADMINISTER_QM_SURVEYS = 'AdministerQMSurveys'
/** @deprecated use `Permissions` type */
export const ADMINISTER_SNMP_CONFIGURATION = 'AdministerSNMPConfiguration'
/** @deprecated use `Permissions` type */
export const ADMINISTER_TENANT_IT = 'AdministerTenantIT'
/** @deprecated use `Permissions` type */
export const ADMINISTER_WFM_REPORTS = 'AdministerWFMReports'
/** @deprecated use `Permissions` type */
export const AMPLIFAI_PERFORMANCE_USER = 'AmplifAIPerformanceUser'
/** @deprecated use `Permissions` type */
export const AMPLIFAI_COACH_USER = 'AmplifAICoachUser'
/** @deprecated use `Permissions` type */
export const AMPLIFAI_SYSADMIN_USER = 'AmplifAISysAdminUser'
/** @deprecated use `Permissions` type */
export const AMPLIFAI_OBSERVER_USER = 'AmplifAIObserverUser'
/** @deprecated use `Permissions` type */
export const ANALYTICS_CONFIGURATION = 'AnalyticsConfig'
/** @deprecated use `Permissions` type */
export const APPROVE_QUALITY_CONTACT = 'ApproveQualityContact'
/** @deprecated use `Permissions` type */
export const BULK_CONTACT_EXPORT = 'BulkContactExport'
/** @deprecated use `Permissions` type */
export const VIEW_BULK_CONTACT_EXPORT = 'ViewBulkContactExport'
/** @deprecated use `Permissions` type */
export const BUSINESS_NOTIFICATIONS = 'BusinessNotifications'
/** @deprecated use `Permissions` type */
export const CALIBRATE_CONTACT = 'CalibrateContact'
/** @deprecated use `Permissions` type */
export const CAPTURE_DESKTOP_ANALYTICS = 'CaptureDesktopAnalytics'
/** @deprecated use `Permissions` type */
export const CREATE_CALIBRATION_GOAL = 'CreateCalibrationGoal'
/** @deprecated use `Permissions` type */
export const CREATE_COMMENT_EVALUATION = 'CreateCommentEvaluation'
/** @deprecated use `Permissions` type */
export const CREATE_CONTACT = 'CreateContact'
/** @deprecated use `Permissions` type */
export const CREATE_EVALUATION_GOAL = 'CreateEvaluationGoal'
/** @deprecated use `Permissions` type */
export const CREATE_REVIEW_GOAL = 'CreateReviewGoal'
/** @deprecated use `Permissions` type */
export const CREATE_ROLES = 'CreateRoles'
/** @deprecated use `Permissions` type */
export const CREATE_SYSTEM_LICENSE = 'CreateSystemLicense'
/** @deprecated use `Permissions` type */
export const DELETE_CONTACT = 'DeleteContact'
/** @deprecated use `Permissions` type */
export const EDIT_ANY_EVALUATION = 'EditAnyEvaluation'
/** @deprecated use `Permissions` type */
export const EDIT_COMMENT_EVALUATION = 'EditCommentEvaluation'
/** @deprecated use `Permissions` type */
export const EDIT_CUSTOM_METADATA = 'EditCustomMetadata'
/** @deprecated use `Permissions` type */
export const EDIT_SCHEDULES = 'EditSchedules'
/** @deprecated use `Permissions` type */
export const EVALUATE_QUALITY_CONTACT = 'EvaluateQualityContact'
/** @deprecated use `Permissions` type */
export const EXPORT_RECORDINGS = 'ExportRecordings'
/** @deprecated use `Permissions` type */
export const LIVE_MONITORING = 'LiveMonitoring'
/** @deprecated use `Permissions` type */
export const LOGIN_LOGOUT_COMMAND_UI = 'LoginLogoutCommandUI'
/** @deprecated use `Permissions` type */
export const MARK_FOR_HR = 'MarkForHR'
/** @deprecated use `Permissions` type */
export const MARK_FOR_TRAINING = 'MarkForTraining'
/** @deprecated use `Permissions` type */
export const PAUSE_RESUME_COMMAND_UI = 'PauseResumeCommandUI'
/** @deprecated use `Permissions` type */
export const PLAN_SCHEDULES = 'PlanSchedules'
/** @deprecated use `Permissions` type */
export const QM_APP_MANAGEMENT = 'QMAppManagement'
/** @deprecated use `Permissions` type */
export const QM_REPORTS = 'QMReports'
/** @deprecated use `Permissions` type */
export const RECORD_ON_DEMAND = 'RecordOnDemand'
/** @deprecated use `Permissions` type */
export const RECORD_VOICE = 'RecordVoice'
/** @deprecated use `Permissions` type */
export const RECORDING_ADD_METADATA = 'RecordingAddMetadata'
/** @deprecated use `Permissions` type */
export const RECORDING_PAUSE_RESUME = 'RecordingPauseResume'
/** @deprecated use `Permissions` type */
export const RECORDING_START_STOP_SEGMENT = 'RecordingStartStopSegment'
/** @deprecated use `Permissions` type */
export const RECORDING_TAG_CONTACT = 'RecordingTagContact'
/** @deprecated use `Permissions` type */
export const RECORDING_UNTAG_CONTACT = 'RecordingUnTagContact'

/**
 * Permission for user to see the Data Explorer Reports and Dashboards
 * Use ViewBIContent instead
 * @deprecated
 */
export const REPORT_AUTHORING = 'ReportAuthoring'
/** @deprecated use `Permissions` type */
export const SCHEDULE_APP_MANAGEMENT = 'ScheduleAppManagement'
/** @deprecated use `Permissions` type */
export const SEARCH_CONTACTS = 'SearchContacts'
/** @deprecated use `Permissions` type */
export const SEARCH_SCORED_CONTACTS = 'SearchScoredContacts'
/** @deprecated use `Permissions` type */
export const SELF_APPROVE_QUALITY_CONTACT = 'SelfApproveQualityContact'
/** @deprecated use `Permissions` type */
export const SELF_CALIBRATE_CONTACT = 'SelfCalibrateContact'
/** @deprecated use `Permissions` type */
export const SELF_EVALUATE_QUALITY_CONTACT = 'SelfEvaluateQualityContact'
/** @deprecated use `Permissions` type */
export const START_STOP_SCREEN_COMMAND_UI = 'StartStopScreenCommandUI'
/** @deprecated use `Permissions` type */
export const START_STOP_SEGMENT_COMMAND_UI = 'StartStopSegmentCommandUI'
/** @deprecated use `Permissions` type */
export const SUPERVISOR_WFM_REPORTS = 'SupervisorWFMReports'
/** @deprecated use `Permissions` type */
export const SUPPORT_NOTIFICATIONS = 'SupportNotifications'
/** @deprecated use `Permissions` type */
export const SYSTEM_METRICS = 'SystemMetrics'
/** @deprecated use `Permissions` type */
export const TAG_COMMAND_UI = 'TagCommandUI'
/** @deprecated use `Permissions` type */
export const UPDATE_ANALYTICS = 'UpdateAnalytics'
/** @deprecated use `Permissions` type */
export const UPDATE_MESSAGING_REQUESTS = 'UpdateMessagingRequests'
/** @deprecated use `Permissions` type */
export const UPDATE_TEAM = 'UpdateTeam'
/** @deprecated use `Permissions` type */
export const UPDATE_TENANT = 'UpdateTenant'
/** @deprecated use `Permissions` type */
export const VIEW_ADVANCED_ANALYTICS = 'ViewAdvancedAnalytics'
/** @deprecated use `Permissions` type */
export const VIEW_ALL_HR_CONTACTS = 'ViewAllHRContacts'
/** @deprecated use `Permissions` type */
export const VIEW_API_DOCUMENTATION = 'ViewAPIDocumentation'
/** @deprecated use `Permissions` type */
export const VIEW_AUDIO_ANALYTICS = 'ViewAudioAnalytics'
/** @deprecated use `Permissions` type */
export const VIEW_CAA_IN_RECORDING_APP = 'ViewCAAInRecordingApp'
/** @deprecated use `Permissions` type */
export const VIEW_CONTACT_GOAL = 'ViewContactGoal'
/** @deprecated use `Permissions` type */
export const VIEW_CUSTOM_METADATA = 'ViewCustomMetadata'
/** @deprecated use `Permissions` type */
export const VIEW_DATA_EXPLORER_GALLERY = 'ViewDataExplorerGallery'
/** @deprecated use `Permissions` type */
export const VIEW_DESKTOP_ANALYTICS = 'ViewDesktopAnalytics'
/** @deprecated use `Permissions` type */
export const VIEW_DEVICE_CONFIG = 'ViewDeviceConfig'
/** @deprecated use `Permissions` type */
export const VIEW_EVALUATIONS = 'ViewEvaluations'
/** @deprecated use `Permissions` type */
export const VIEW_EVALUATOR_DETAILS = 'ViewEvaluatorDetails'
/** @deprecated use `Permissions` type */
export const VIEW_HOME_PAGE = 'ViewHomePage'
/** @deprecated use `Permissions` type */
export const VIEW_LVCSR_ANALYTICS = 'ViewLvcsrAnalytics'
/** @deprecated use `Permissions` type */
export const VIEW_ORG = 'ViewOrg'
/** @deprecated use `Permissions` type */
export const VIEW_QM_DASHBOARD = 'ViewQMDashboard'
/** @deprecated use `Permissions` type */
export const VIEW_ROOT_RECORDINGS = 'ViewRootRecordings'
/** @deprecated use `Permissions` type */
export const VIEW_SCHEDULES = 'ViewSchedules'
/** @deprecated use `Permissions` type */
export const VIEW_SURVEY_RESULTS = 'ViewSurveyResults'
/** @deprecated use `Permissions` type */
export const VIEW_SYSTEM_ANALYTICS = 'ViewSystemAnalytics'
/** @deprecated use `Permissions` type */
export const VIEW_TENANT = 'ViewTenant'
/** @deprecated use `Permissions` type */
export const VIEW_TEXT_ANALYTICS = 'ViewTextAnalytics'
/** @deprecated use `Permissions` type */
export const VIEW_WFM_DASHBOARD = 'ViewWFMDashboard'
/** @deprecated use `Permissions` type */
export const WFM_APP_MANAGEMENT = 'WFMAppManagement'
/** @deprecated use `Permissions` type */
export const WFM_REPORTS = 'WFMReports'
/** @deprecated use `Permissions` type */
export const VIEW_SENTIMENT = 'SentimentView'

/**
 * Permission for user to see the DX Home Dashboard
 * @deprecated use 'ViewBIHome' from `Permissions` type
 */
export const DATA_EXPLORER = 'DataExplorer'
/** @deprecated use `Permissions` type */
export const UPDATE_ORG = 'UpdateOrg'

/**
 * Granular permissions.
 * Epic 31278: Permissions (Integration of Advanced Reporting into Calabrio ONE)
 * https://dev.azure.com/Calabrio/BI/_workitems/edit/31278
 * @deprecated use `Permissions` type
 */
export const VIEW_BI_HOME = 'ViewBIHome'
/** @deprecated use `Permissions` type */
export const VIEW_BI_CONTENT = 'ViewBIContent'
/** @deprecated use `Permissions` type */
export const CREATE_BI_CONTENT = 'CreateBIContent'
/** @deprecated use `Permissions` type */
export const PUBLISH_BI_CONTENT = 'PublishBIContent'
/** @deprecated use `Permissions` type */
export const MANAGE_DELIVERY = 'ManageBIDelivery'
/** @deprecated use `Permissions` type */
export const DELIVER_BI_CONTENT = 'DeliverBIContent'
/** @deprecated use `Permissions` type */
export const VIEW_DATALIBRARY = 'ViewBIDataLibrary'
/** @deprecated use `Permissions` type */
export const DESIGN_DATALIBRARY = 'DesignBIDataLibrary'
/** @deprecated use `Permissions` type */
export const PUBLISH_DATALIBRARY = 'PublishBIDataLibrary'
/** @deprecated use `Permissions` type */
export const ADMIN_DATA_TASKS = 'AdminBITasks'
/** @deprecated use `Permissions` type */
export const ADMIN_UDM_CONNECTOR = 'AdminBIUDM'
/** @deprecated use `Permissions` type */
export const ADMIN_RT_CONNECTOR = 'AdminBIRT'
/** @deprecated use `Permissions` type */
export const ADMIN_SHARING_GROUPS = 'AdminBISharingGroups'
/** @deprecated use `Permissions` type */
export const MANAGE_BI_INFOSPACE = 'ManageBIInfospace'
/** @deprecated use `Permissions` type */
export const ADMINISTER_SYS_ADMIN = 'AdministerSysAdmin'
/** @deprecated use `Permissions` type */
export const SMART_TAG_EDITOR_VIEW = 'SmartTagEditorView'
/** @deprecated use `Permissions` type */
export const SMART_TAG_EDITOR_EDIT = 'SmartTagEditorEdit'
/** @deprecated use `Permissions` type */
export const ADMIN_PHRASES = 'AdminPhrases'

export const BI_PERMISSION_SET = new Set([
  DATA_EXPLORER,
  REPORT_AUTHORING,
  VIEW_BI_HOME,
  VIEW_BI_CONTENT,
  CREATE_BI_CONTENT,
  PUBLISH_BI_CONTENT,
  MANAGE_DELIVERY,
  DELIVER_BI_CONTENT,
  VIEW_DATALIBRARY,
  DESIGN_DATALIBRARY,
  PUBLISH_DATALIBRARY,
  ADMIN_DATA_TASKS,
  ADMIN_UDM_CONNECTOR,
  ADMIN_RT_CONNECTOR,
  ADMIN_SHARING_GROUPS,
  MANAGE_BI_INFOSPACE,
])

export type Permission =
  | typeof ACCESS_RECYCLE_BIN
  | typeof ADD_METADATA_COMMAND_UI
  | typeof ADMIN_ACD_CONFIGURATION
  | typeof ADMIN_AUDIO_ANALYTICS
  | typeof ADMIN_DATA_TASKS
  | typeof ADMIN_DESKTOP_ANALYTICS
  | typeof ADMIN_EVALUATION_FORM
  | typeof ADMIN_LVCSR_ANALYTICS
  | typeof ADMIN_RT_CONNECTOR
  | typeof ADMIN_SHARING_GROUPS
  | typeof ADMIN_TEXT_ANALYTICS
  | typeof ADMIN_UDM_CONNECTOR
  | typeof ADMINISTER_ANALYTICS_SETTINGS
  | typeof ADMINISTER_DASHBOARD
  | typeof ADMINISTER_DISTRIBUTION_LIST
  | typeof ADMINISTER_MESSAGING
  | typeof ADMINISTER_QM_REPORTS
  | typeof ADMINISTER_QM_SURVEYS
  | typeof ADMINISTER_SNMP_CONFIGURATION
  | typeof ADMINISTER_TENANT_IT
  | typeof ADMINISTER_WFM_REPORTS
  | typeof AMPLIFAI_COACH_USER
  | typeof AMPLIFAI_OBSERVER_USER
  | typeof AMPLIFAI_PERFORMANCE_USER
  | typeof AMPLIFAI_SYSADMIN_USER
  | typeof ANALYTICS_CONFIGURATION
  | typeof APPROVE_QUALITY_CONTACT
  | typeof BULK_CONTACT_EXPORT
  | typeof BUSINESS_NOTIFICATIONS
  | typeof CALIBRATE_CONTACT
  | typeof CAPTURE_DESKTOP_ANALYTICS
  | typeof CREATE_BI_CONTENT
  | typeof CREATE_CALIBRATION_GOAL
  | typeof CREATE_COMMENT_EVALUATION
  | typeof CREATE_CONTACT
  | typeof CREATE_EVALUATION_GOAL
  | typeof CREATE_REVIEW_GOAL
  | typeof CREATE_ROLES
  | typeof CREATE_SYSTEM_LICENSE
  | typeof DATA_EXPLORER
  | typeof DELETE_CONTACT
  | typeof DELIVER_BI_CONTENT
  | typeof DESIGN_DATALIBRARY
  | typeof EDIT_ANY_EVALUATION
  | typeof EDIT_COMMENT_EVALUATION
  | typeof EDIT_CUSTOM_METADATA
  | typeof EDIT_SCHEDULES
  | typeof EVALUATE_QUALITY_CONTACT
  | typeof EXPORT_RECORDINGS
  | typeof LIVE_MONITORING
  | typeof LOGIN_LOGOUT_COMMAND_UI
  | typeof MANAGE_BI_INFOSPACE
  | typeof MANAGE_DELIVERY
  | typeof MARK_FOR_HR
  | typeof MARK_FOR_TRAINING
  | typeof PAUSE_RESUME_COMMAND_UI
  | typeof PLAN_SCHEDULES
  | typeof PUBLISH_BI_CONTENT
  | typeof PUBLISH_DATALIBRARY
  | typeof QM_APP_MANAGEMENT
  | typeof QM_REPORTS
  | typeof RECORD_ON_DEMAND
  | typeof RECORD_VOICE
  | typeof RECORDING_ADD_METADATA
  | typeof RECORDING_PAUSE_RESUME
  | typeof RECORDING_START_STOP_SEGMENT
  | typeof RECORDING_TAG_CONTACT
  | typeof RECORDING_UNTAG_CONTACT
  | typeof REPORT_AUTHORING
  | typeof SCHEDULE_APP_MANAGEMENT
  | typeof SEARCH_CONTACTS
  | typeof SEARCH_SCORED_CONTACTS
  | typeof SELF_APPROVE_QUALITY_CONTACT
  | typeof SELF_CALIBRATE_CONTACT
  | typeof SELF_EVALUATE_QUALITY_CONTACT
  | typeof START_STOP_SCREEN_COMMAND_UI
  | typeof START_STOP_SEGMENT_COMMAND_UI
  | typeof SUPERVISOR_WFM_REPORTS
  | typeof SUPPORT_NOTIFICATIONS
  | typeof SYSTEM_METRICS
  | typeof TAG_COMMAND_UI
  | typeof UPDATE_ANALYTICS
  | typeof UPDATE_MESSAGING_REQUESTS
  | typeof UPDATE_ORG
  | typeof UPDATE_TEAM
  | typeof UPDATE_TENANT
  | typeof VIEW_ADVANCED_ANALYTICS
  | typeof VIEW_ALL_HR_CONTACTS
  | typeof VIEW_API_DOCUMENTATION
  | typeof VIEW_AUDIO_ANALYTICS
  | typeof VIEW_BI_CONTENT
  | typeof VIEW_BI_HOME
  | typeof VIEW_BULK_CONTACT_EXPORT
  | typeof VIEW_CAA_IN_RECORDING_APP
  | typeof VIEW_CONTACT_GOAL
  | typeof VIEW_CUSTOM_METADATA
  | typeof VIEW_DATA_EXPLORER_GALLERY
  | typeof VIEW_DATALIBRARY
  | typeof VIEW_DESKTOP_ANALYTICS
  | typeof VIEW_DEVICE_CONFIG
  | typeof VIEW_EVALUATIONS
  | typeof VIEW_EVALUATOR_DETAILS
  | typeof VIEW_HOME_PAGE
  | typeof VIEW_LVCSR_ANALYTICS
  | typeof VIEW_ORG
  | typeof VIEW_QM_DASHBOARD
  | typeof VIEW_ROOT_RECORDINGS
  | typeof VIEW_SCHEDULES
  | typeof VIEW_SURVEY_RESULTS
  | typeof VIEW_SYSTEM_ANALYTICS
  | typeof VIEW_TENANT
  | typeof VIEW_TEXT_ANALYTICS
  | typeof VIEW_WFM_DASHBOARD
  | typeof WFM_APP_MANAGEMENT
  | typeof WFM_REPORTS
  | typeof ADMINISTER_SYS_ADMIN
  | 'AdminAdvancedAnalytics'
  | 'AdministerActiveDirectoryAuth'
  | 'AdministerEncryptionKeys'
  | 'AdministerGamification'
  | 'AdministerPasswordPolicy'
  | 'AdministerQMContactGoals'
  | 'AdminReconTasks'
  | 'AdvancedReportingAPI'
  | 'AssignRoles'
  | 'BulkDelete'
  | 'BulkImport'
  | 'DesktopCaptureEvents'
  | 'EditQmViews'
  | 'EditWfmViews'
  | 'HasGlobalTrainingScope'
  | 'LiveAudioMonitoring'
  | 'LiveScreenMonitoring'
  | 'MetadataFields'
  | 'MobileDeviceAccess'
  | 'QMEvaluationReports'
  | 'QMSurveyReports'
  | 'QMSystemReports'
  | 'RecordScreen'
  | 'SendRecCtlCommandLoginLogout'
  | 'SendRecCtlCommandMetadata'
  | 'SendRecCtlCommandPauseResume'
  | 'SendRecCtlCommandStartScreenStopScreen'
  | 'SendRecCtlCommandStartStop'
  | 'SendRecCtlCommandTag'
  | 'Sites'
  | 'UpdateGroup'
  | 'ViewAudit'
  | 'ViewCreateHotelingUser'
  | 'ViewDesktopMonitoring'
  | 'ViewGamification'
  | 'ViewTelephonyGroupConfig'
  | 'ViewUnReconciledRootRecordings'
  | 'Workflow'
  | 'BaViewExperienceAutomation'
  | 'BaViewConvDistribution'
  | 'BaViewConvTopics'
  | 'BaViewImpactAnalysis'
  | 'BaViewAggregatedMetrics'
  | 'BaViewTranscriptSearch'
  | 'BaViewVAAOverview'
  | 'BaViewVAAPerformanceComparison'
  | 'BaViewVAAResponsePerformance'
  | 'BaViewVAAUnclassifiedMessages'
  | 'BaViewVAAIntentPerformance'
  | 'BaViewBotManagementReport'
  | 'BaViewBotPerformanceReport'
  | 'AdminPredictiveAnalytics'
  | 'AdminTextAnalytics'
  | 'AdminDesktopAnalytics'
  | 'AdminLvcsrAnalytics'
  | 'AdminPhrases'
  | 'BiInsightsViewContent'
  | 'BiInsightsViewAnalyticsData'
  | 'BiInsightsViewCWFMData'
  | 'BiInsightsViewQMData'
  | 'BiInsightsViewWFMData'
  | 'BiInsightsCreateContent'
  | 'BiInsightsShareContent'
  | 'BiInsightsAdminTenant'
  | 'BiInsightsAdminSystem'
  | 'ViewTrendingTopics'
  | 'AutoQAView'
  | 'AutoQADashboardsView'
  | 'AutoQARun'
  | 'BulkUpdateRetention'
  | 'BulkUpdateMetadata'
  | 'AdminTrendingTopics'
  | 'SentimentView'
  | 'AutoQARunTask'
  | 'TrendingTopicsRunTask'
  | 'SentimentRunTask'
  | 'SmartTagView'
  | 'SmartTagRunTask'
  | 'SmartTagEditorView'
  | 'SmartTagEditorEdit'
